/**
 * Format a date string or Date object to "DD-Mon-YYYY" format (e.g., "31-Jul-2026")
 * @param {string|Date} input - ISO string, date string, or Date object
 * @returns {string} Formatted date or '-' if invalid
 */
export function formatDisplayDate(input) {
  if (!input) return '-';
  try {
    const d = typeof input === 'string' ? new Date(input) : input;
    if (isNaN(d.getTime())) return '-';
    const day = String(d.getDate()).padStart(2, '0');
    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const mon = months[d.getMonth()];
    const year = d.getFullYear();
    return `${day}-${mon}-${year}`;
  } catch {
    return '-';
  }
}

/**
 * "DD-Mon" for chart axes, where the year would repeat on every tick (e.g., "31-Jul").
 */
export function formatDayMonth(input) {
  const s = formatDisplayDate(input);
  return s === '-' ? '' : s.slice(0, 6);
}

/**
 * A chart label in the app's date format when it is an ISO date ("2026-07-31" -> "31-Jul-2026");
 * any other label (a zone, an FE name) is returned unchanged.
 */
export function formatChartLabel(label) {
  return typeof label === 'string' && /^\d{4}-\d{2}-\d{2}/.test(label) ? formatDisplayDate(label) : label;
}

/**
 * Format a date with time: "DD-Mon-YYYY HH:MM"
 */
export function formatDisplayDateTime(input) {
  if (!input) return '-';
  try {
    const d = typeof input === 'string' ? new Date(input) : input;
    if (isNaN(d.getTime())) return '-';
    const date = formatDisplayDate(d);
    const time = d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });
    return `${date} ${time}`;
  } catch {
    return '-';
  }
}
